// components

enum OnboardingActionType {
  Next = 'next',
  Skip = 'nextSection',
  Back = 'back',
  End = 'end',
  Previous = 'previous',
  To = 'to',
}

export const onboardingHeroConfig = [
  {
    id: 'hero1',
    title: 'Dedicated adult care support at your fingertips',
    text1:
      'Get practical, expert help at every stage of your caregiving journey',
    ctaButtonLabel: 'Start your journey',
    actions: null,
  },
];

export const onboardingHeroIFAConfig = [
  {
    id: 'hero1',
    title: 'Grow your long-term care advice business with KareHero',
    text1: 'A support blanked for your clients in later life',
    ctaButtonLabel: 'Get started',
    actions: null,
  },
];

export const onboardingMemberCarouselConfig = [
  {
    id: '1',
    subTitle: 'Bespoke Care Assessment',
    imgUrl:
      'https://cdn.sanity.io/images/x7r1t5o8/production/81fdf050852681b3032f44dea9690592f3a7741c-1077x556.jpg?h=800',
    text: 'Get expert care options for your loved one',
    isIgnoreProgress: true,
    actions: [
      {
        label: 'Continue',
        onClick: OnboardingActionType.Next,
        isFullWidth: true,
      },
    ],
  },
  {
    id: '2',
    subTitle: 'Personalised Funding Consultation',
    imgUrl:
      'https://cdn.sanity.io/images/x7r1t5o8/production/f573b09707af7fded054e071f8a163bb2ed9e031-1626x1083.jpg?h=800',
    text: 'Know your care costs and get funding help',
    isIgnoreProgress: true,
    actions: [
      {
        label: 'Continue',
        onClick: OnboardingActionType.Next,
        isFullWidth: true,
      },
    ],
  },
  {
    id: '3',
    subTitle: '1:1 Unlimited Access to Experts',
    imgUrl:
      'https://cdn.sanity.io/images/x7r1t5o8/production/c8547a5264282d404fb52141c9ffd0ac8db0665a-1045x459.jpg?h=800',
    text: 'Get answers from dedicated human experts',
    isIgnoreProgress: true,
    actions: [
      {
        label: 'Continue',
        onClick: OnboardingActionType.Next,
        isFullWidth: true,
      },
    ],
  },
];

export const onboardingCarouselConfig = [
  {
    id: '1',
    subTitle: 'Set your clients up for later life success',
    imgUrl:
      'https://cdn.sanity.io/images/x7r1t5o8/production/e8579e2a4c3766cf0cf99a24a9d0679d2d2bbeb4-5322x2365.jpg?h=800',
    text: 'KareHero supports your clients to find care and navigate care costs',
  },
  {
    id: '2',
    subTitle: 'Save time and admin on care research',
    imgUrl:
      'https://cdn.sanity.io/images/x7r1t5o8/production/8d3660ea13e7547c5abd2f4ec09abe105afe7376-7934x5292.jpg?h=800',
    text: 'Our trusted care experts give your clients 1:1 advice',
  },
  {
    id: '3',
    subTitle: 'Track your client’s progress and access expert resources',
    imgUrl:
      'https://cdn.sanity.io/images/x7r1t5o8/production/084b805fc677b014ad2eefdd1640a86758727fdc-8190x3333.jpg?h=800',
    text: 'Your KareHero Portal lets you manage your referrals all in one place',
  },
];

export const onboardingKeniConfirmEmailConfig = [
  {
    id: 'keni1',
    title: 'Almost there!',
    subTitle: "Please verify it's you by clicking the link in your email",
    keniSpeech: [
      {
        type: 'strong',
        text: 'Head over to your work email inbox!',
      },
    ],
    keniWidth: '300px',
    actions: [
      {
        label: 'Done',
        onClick: OnboardingActionType.To,
        to: '/sign-in',
      },
    ],
  },
];

export const onboardingLoadingConfig = [
  {
    id: '1',
    icon: 'star',
    text: 'Building your personalised action plan',
    color: 'orange',
    actions: null,
    isIgnoreProgress: true,
  },
  {
    id: '2',
    icon: 'hand-holding-heart',
    text: 'Working out your care needs',
    color: 'red',
    actions: null,
    isIgnoreProgress: true,
  },
  {
    id: '3',
    icon: 'money-bills',
    text: 'Calculating funding options',
    color: 'green',
    actions: null,
    isIgnoreProgress: true,
  },
  {
    id: '4',
    icon: 'route',
    text: 'Finalising your next steps',
    color: 'lime',
    actions: null,
    isIgnoreProgress: true,
  },
];
